import { FormikValues, useFormikContext } from "formik";
import React, { FC } from "react";
import FormDropdownField from "../../../../../common/Form/Dropdown/FormDropdownField";
import { Typography } from "@mui/material";

interface IProps {
  name: string;
  options: string[];
  label: string;
  placeholder: string;
  setGrid?: React.Dispatch<React.SetStateAction<string[]>>;
  disabled: boolean;
  callBack?: (fieldName: string, value: any) => void;
  [x: string]: any;
}

const DropdownWithOther: FC<IProps> = (props) => {
  const {
    name,
    label,
    placeholder,
    options,
    setGrid,
    disabled,
    callBack,
    ...rest
  } = props;

  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.value);
  };

  const addOptionToGrid = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(name, e.target.value);
  };

  const dropdownInputHandler = (fieldName: string, value: any) => {
    setFieldValue(fieldName, value);
    callBack?.(fieldName, value);
  };

  return (
    <div className="mg-b-50">
      {disabled ? (
        <>
          <label className="form-label mg-b-20 font-size-14 font-weight-medium">
            {label}
          </label>
          <Typography variant={"body1"} component={"h3"} color={"secondary"}>
            {values[name]}
          </Typography>
        </>
      ) : (
        <FormDropdownField
          label={label}
          value={values[name]}
          name={name}
          className=""
          placeholder={placeholder}
          options={options}
          inputHandler={dropdownInputHandler}
          disabled={disabled}
          freeSolo={false}
          {...rest}
        />
      )}
      {values[name] === "Others" && (
        <input
          className="form-control mg-t-20"
          name={`${name}Others`}
          value={values[`${name}Others`]}
          onChange={inputHandler}
          onBlur={addOptionToGrid}
          placeholder={placeholder}
          {...rest}
        />
      )}
    </div>
  );
};

export default DropdownWithOther;
